import { Box, Link, Typography, useTheme } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

import { whatsappFeedbackUrl } from "../../support/support-data";

// ----------------------------------------------------------------------

interface FeedbackInviteProps {
  /** true no hero mobile (fundo dourado): ícone e texto em branco */
  onBrand?: boolean;
}

const WHATSAPP_GREEN = "#25D366";

/** Linha "O que achou da nova experiência? Estamos abertos a feedbacks, fale com a gente" com o ícone do WhatsApp. */
export default function FeedbackInvite({ onBrand = false }: FeedbackInviteProps) {
  const theme = useTheme();
  const textColor = onBrand ? "rgba(255,255,255,0.85)" : theme.palette.brand.heroText;
  const linkColor = onBrand ? theme.palette.common.white : theme.palette.primary.main;
  const iconColor = onBrand ? theme.palette.common.white : WHATSAPP_GREEN;

  return (
    // Ícone alinhado à primeira linha: no mobile a frase quebra em mais de uma.
    <Box sx={{ display: "flex", alignItems: "flex-start", gap: "6px" }}>
      <WhatsAppIcon sx={{ fontSize: 18, color: iconColor, flexShrink: 0, mt: "1px" }} />
      <Typography sx={{ fontSize: onBrand ? "12.5px" : "13.5px", lineHeight: 1.45, color: textColor }}>
        O que achou da nova experiência? Estamos abertos a feedbacks,{" "}
        <Link
          href={whatsappFeedbackUrl()}
          target="_blank"
          rel="noopener noreferrer"
          sx={{ color: linkColor, fontWeight: 600, textDecorationColor: linkColor }}
        >
          fale com a gente
        </Link>
      </Typography>
    </Box>
  );
}
